import { useRouter } from 'next/router';
import { getSession } from 'next-auth/react';
import { isEmpty } from 'lodash';

import Layout from '@/components/layout/basic';
import Home from '@/components/home';

/**
 * Index page.
 *
 * @returns
 */
const IndexPage = () => {
    const router = useRouter();
    const { selected } = router?.query ?? {};

    return (
        <Layout
            title="Welcome to Flood Portal"
            description="Enter your policy details to pay a renewal bill, file a claim, or access policy documents."
        >
            <Home title="Welcome to Flood Portal" selected={selected} />
        </Layout>
    );
};

export async function getServerSideProps(context) {
    const props = {};
    const session = await getSession(context);

    if (!isEmpty(session)) {
        return {
            redirect: {
                permanent: false,
                destination: '/home'
            },
            props
        };
    }

    return {
        props
    };
}

export default IndexPage;
